import { postMethodWithTokenWithLatLng } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const ADD_CAMPAIGN_SUCCESS = 'ADD_CAMPAIGN_SUCCESS';
export const ADD_CAMPAIGN_FAILURE = 'ADD_CAMPAIGN_FAILURE';

// Action Creators
export const fetchAddCampaign = () => ({
  type: ADD_CAMPAIGN,
});

export const fetchAddCampaignSuccess = (data) => ({
  type: ADD_CAMPAIGN_SUCCESS,
  payload: data,
});

export const fetchAddCampaignFailure = (error) => ({
  type: ADD_CAMPAIGN_FAILURE,
  payload: error,
});

// Thunk Function
export const addCampaignCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchAddCampaign(data, external));
    try {
      const response = await postMethodWithTokenWithLatLng(
        url.addCampaignListSuperAdmin,
        data,
        external?.latlng
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAddCampaignSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchAddCampaignFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchAddCampaignFailure(error.message));
    }
  };
};
